import { getCompanyHighlights } from "@/company/services/company-highlights-service";
import {
  GetCompanyHighlightsParams,
  GetCompanyHighlightsResponse,
} from "@/company/types";
import { useQuery, UseQueryResult } from "@tanstack/react-query";

const useCompanyHighlights = ({
  companyId,
}: GetCompanyHighlightsParams): UseQueryResult<GetCompanyHighlightsResponse> => {
  const params = { companyId };

  return useQuery<GetCompanyHighlightsResponse>({
    queryKey: ["company-highlights", params],
    queryFn: async ({ signal }) => {
      return await getCompanyHighlights(params, signal);
    },
  });
};

export { useCompanyHighlights };
